import { useState, useEffect } from 'react'

export const useNotificaciones = () => {
  const [permiso, setPermiso] = useState(Notification.permission)
  const [swRegistrado, setSwRegistrado] = useState(false)

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/sw.js')
        .then(reg => {
          setSwRegistrado(true)
          console.log('SW registrado')
        })
        .catch(err => console.error('SW error:', err))
    }
  }, [])

  const pedirPermiso = async () => {
    if (!('Notification' in window)) return false
    const result = await Notification.requestPermission()
    setPermiso(result)
    return result === 'granted'
  }

  const programarNotificacion = async (title, body, delay, tag = 'dayflow') => {
    if (permiso !== 'granted') {
      const ok = await pedirPermiso()
      if (!ok) return
    }

    const reg = await navigator.serviceWorker.ready
    if (reg?.active) {
      reg.active.postMessage({
        type: 'SCHEDULE_NOTIFICATION',
        title,
        body,
        delay,
        tag,
      })
    }
  }

  const notificarAhora = async (title, body, tag = 'dayflow') => {
    if (permiso !== 'granted') {
      const ok = await pedirPermiso()
      if (!ok) return
    }
    const reg = await navigator.serviceWorker.ready
    reg.showNotification(title, {
      body,
      icon:    '/favicon.ico',
      badge:   '/favicon.ico',
      tag,
      vibrate: [200, 100, 200],
    })
  }

  const programarRecordatorioTareas = async (tareas) => {
    if (permiso !== 'granted') await pedirPermiso()
    const hoy = new Date().toISOString().split('T')[0]
    const ahora = Date.now()

    tareas
      .filter(t => !t.hecha && t.fecha === hoy && t.hora)
      .forEach(t => {
        const dt = new Date(`${t.fecha}T${t.hora}`)
        const delay = dt.getTime() - ahora
        if (delay > 0) {
          programarNotificacion(
            `⏰ ${t.nombre}`,
            t.descripcion || 'Es hora de hacer esta tarea',
            delay,
            `tarea-${t.id}`
          )
        }
      })
  }

  const programarRecordatorioHabitos = async (habitos) => {
    if (permiso !== 'granted') await pedirPermiso()
    const hoy = new Date().toISOString().split('T')[0]
    const pendientes = habitos.filter(h => !h.registros?.includes(hoy))

    if (pendientes.length === 0) return

    // Recordatorio a las 20hs si hay hábitos sin completar
    const ahora = new Date()
    const recordatorio = new Date()
    recordatorio.setHours(20, 0, 0, 0)

    if (recordatorio > ahora) {
      const delay = recordatorio.getTime() - ahora.getTime()
      programarNotificacion(
        '🔥 Hábitos pendientes',
        `Todavía te faltan ${pendientes.length} hábito${pendientes.length !== 1 ? 's' : ''} por completar hoy`,
        delay,
        'habitos-recordatorio'
      )
    }
  }

  return {
    permiso,
    swRegistrado,
    pedirPermiso,
    notificarAhora,
    programarNotificacion,
    programarRecordatorioTareas,
    programarRecordatorioHabitos,
  }
}